var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconShieldCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.54.418a1.667 1.667 0 012.21 0 18.333 18.333 0 0012.986 4.584 1.667 1.667 0 011.675 1.195A21.666 21.666 0 0117.064 33.28a1.666 1.666 0 01-.837 0A21.665 21.665 0 01.88 6.197a1.667 1.667 0 011.675-1.195A18.334 18.334 0 0015.54.418zM3.766 8.351a18.333 18.333 0 0012.88 21.588 18.332 18.332 0 0012.88-21.588 21.668 21.668 0 01-12.88-4.522A21.667 21.667 0 013.765 8.35zm19.059 3.804c.65.65.65 1.706 0 2.357l-6.667 6.666c-.65.651-1.706.651-2.357 0l-3.333-3.333a1.667 1.667 0 112.357-2.357l2.155 2.155 5.488-5.488c.65-.651 1.706-.651 2.357 0z",
    fill: "#212529"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.54.418a1.667 1.667 0 012.21 0 18.333 18.333 0 0012.986 4.584 1.667 1.667 0 011.675 1.195A21.666 21.666 0 0117.064 33.28a1.666 1.666 0 01-.837 0A21.665 21.665 0 01.88 6.197a1.667 1.667 0 011.675-1.195A18.334 18.334 0 0015.54.418zM3.766 8.351a18.333 18.333 0 0012.88 21.588 18.332 18.332 0 0012.88-21.588 21.668 21.668 0 01-12.88-4.522A21.667 21.667 0 013.765 8.35zm19.059 3.804c.65.65.65 1.706 0 2.357l-6.667 6.666c-.65.651-1.706.651-2.357 0l-3.333-3.333a1.667 1.667 0 112.357-2.357l2.155 2.155 5.488-5.488c.65-.651 1.706-.651 2.357 0z",
    fill: "#000",
    fillOpacity: 0.2
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon--shield-check-46b449fab0fdc6ceb180a48cab5f9958.svg";
export { SvgIconShieldCheck as Component };